var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"index-header"},[_c('img',{staticClass:"desktop",attrs:{"src":_vm.index_banner,"alt":""}}),_vm._v(" "),_c('img',{staticClass:"mobile",attrs:{"src":_vm.index_banner_m,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"scroll-down-wrapper",on:{"click":function($event){return _vm.scrollDown('#brand-intro')}}},[_c('img',{attrs:{"src":_vm.scroll_down,"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd39029","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Index/Header.vue
// module id = 93
// module chunks = 0